<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<li>
				<span>1、船头照</span>
				<img class="img" :src="dataList.jy001" />
			</li>
			<li>
				<span>2、合照（现场检验员和船舶）</span>
				<img class="img" :src="dataList.jy002" />
			</li>
			<li>
				<span>3、工作中的照片</span>
				<img class="img" :src="dataList.jy003" />
			</li>
			<li>
				<span>4、Report No.</span>
				<span>{{ dataList.jy004 }}</span>
			</li>
			<li>
				<span>5、Port</span>
				<span>{{ dataList.jy005 }}</span>
			</li>
			<li>
				<span>6、Vessel name</span>
				<span>{{ dataList.jy006 }}</span>
			</li>
			<li>
				<span>7、barge name -1</span>
				<span>{{ dataList.jy007 }}</span>
			</li>
			<li>
				<span>8、barge name -2</span>
				<span>{{ dataList.jy008 }}</span>
			</li>
			<li>
				<span>9、barge name -3</span>
				<span>{{ dataList.jy009 }}</span>
			</li>
			<li>
				<span>10、Survey time</span>
				<span>{{ dataList.jy010 }}</span>
			</li>
			<li>
				<span>11、单选框下面的多行文本</span>
				<span>{{ dataList.jy011 }}</span>
				<span>{{ dataList.jy01101 }}</span>
			</li>
			<!-- <li>
				<span>11、单选框下面的多行文本</span>
				<span>{{ dataList.jy0111 }}</span>
			</li> -->
			<li>
				<span>
					12、Vessel Pre-pumping
				</span>
				<span>
					Vessel supplied by barge-1
					<ul class="li12">
						<li>
							HSFO：{{dataList.jy01200}}MT
						</li>
						<li>
							LSFO：{{dataList.jy01201}}MT
						</li>
						<li>
							MDO：{{dataList.jy01202}}MT
						</li>
						<li>
							MGO：{{dataList.jy01203}}MT
						</li>
					</ul>
				</span>
				<span>
					Vessel Post-pumping
					<ul class="li12">
						<li>
							HSFO：{{dataList.jy01204}}MT
						</li>
						<li>
							LSFO：{{dataList.jy01205}}MT
						</li>
						<li>
							MDO：{{dataList.jy01206}}MT
						</li>
						<li>
							MGO：{{dataList.jy01207}}MT
						</li>
					</ul>
				</span>
				<span>
					Difference Pre and Post Pumping
					<ul class="li12">
						<li>
							HSFO：{{dataList.jy01208}}M³
								  {{dataList.jy01209}}MT
						</li>
						<li>
							LSFO：{{dataList.jy01210}}M³
								  {{dataList.jy01211}}MT
						</li>
						<li>
							MDO：{{dataList.jy01212}}M³
								  {{dataList.jy01213}}MT
						</li>
						<li>
							MGO：{{dataList.jy01214}}M³
								  {{dataList.jy01215}}MT
						</li>
					</ul>
				</span>
				<span>
					The quantity of refueling tons( In words)
					<ul class="li12">
						<li>
							HSFO：{{dataList.jy01216}}MT
						</li>
						<li>
							LSFO：{{dataList.jy01217}}MT
						</li>
						<li>
							MDO：{{dataList.jy01218}}MT
						</li>
						<li>
							MGO：{{dataList.jy01219}}MT
						</li>
					</ul>
				</span>
			</li>

			<li>
			    <span>
			        13、Vessel Pre-pumping
			    </span>
			    <span>
			        Vessel supplied by barge-2
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01300}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01301}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01302}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01303}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        Vessel Post-pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01304}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01305}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01306}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01307}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        Difference Pre and Post Pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01308}}M³
			                      {{dataList.jy01309}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01310}}M³
			                      {{dataList.jy01311}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01312}}M³
			                      {{dataList.jy01313}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01314}}M³
			                      {{dataList.jy01315}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        The quantity of refueling tons( In words)
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01316}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01317}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01318}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01319}}MT
			            </li>
			        </ul>
			    </span>
			</li>


			<li>
			    <span>
			        14、Vessel Pre-pumping
			    </span>
			    <span>
			        Vessel supplied by barge-3
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01400}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01401}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01402}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01403}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        Vessel Post-pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01404}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01405}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01406}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01407}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        Difference Pre and Post Pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01408}}M³
			                      {{dataList.jy01409}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01410}}M³
			                      {{dataList.jy01411}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01412}}M³
			                      {{dataList.jy01413}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01414}}M³
			                      {{dataList.jy01415}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        The quantity of refueling tons( In words)
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01416}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01417}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01418}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01419}}MT
			            </li>
			        </ul>
			    </span>
			</li>

			<li>
			    <span>
			        15、Vessel Pre-pumping
			    </span>
			    <span>
			        Barge-1 Pre-pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01500}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01501}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01502}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01503}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        Barge-1 Post-pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01504}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01505}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01506}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01507}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        Barge-1 Difference Pre and Post Pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01508}}M³
			                      {{dataList.jy01509}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01510}}M³
			                      {{dataList.jy01511}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01512}}M³
			                      {{dataList.jy01513}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01514}}M³
			                      {{dataList.jy01515}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        The quantity of refueling tons( In words):
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01516}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01517}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01518}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01519}}MT
			            </li>
			        </ul>
			    </span>
			</li>

			<li>
			    <span>
			        16、Vessel Pre-pumping
			    </span>
			    <span>
			        Barge-2 Pre-pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01600}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01601}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01602}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01603}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        Barge-2 Post-pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01604}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01605}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01606}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01607}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        Barge-2 Difference Pre and Post Pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01608}}M³
			                      {{dataList.jy01609}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01610}}M³
			                      {{dataList.jy01611}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01612}}M³
			                      {{dataList.jy01613}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01614}}M³
			                      {{dataList.jy01615}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        The quantity of refueling tons( In words):
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01616}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01617}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01618}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01619}}MT
			            </li>
			        </ul>
			    </span>
			</li>

			<li>
			    <span>
			        17、Vessel Pre-pumping
			    </span>
			    <span>
			        Barge-3 Pre-pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01700}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01701}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01702}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01703}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        Barge-3 Post-pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01704}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01705}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01706}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01707}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        Barge-3 Difference Pre and Post Pumping
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01708}}M³
			                      {{dataList.jy01709}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01710}}M³
			                      {{dataList.jy01711}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01712}}M³
			                      {{dataList.jy01713}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01714}}M³
			                      {{dataList.jy01715}}MT
			            </li>
			        </ul>
			    </span>
			    <span>
			        The quantity of refueling tons( In words):
			        <ul class="li12">
			            <li>
			                HSFO：{{dataList.jy01716}}MT
			            </li>
			            <li>
			                LSFO：{{dataList.jy01717}}MT
			            </li>
			            <li>
			                MDO：{{dataList.jy01718}}MT
			            </li>
			            <li>
			                MGO：{{dataList.jy01719}}MT
			            </li>
			        </ul>
			    </span>
			</li>
			<li>
				<span>18、Barge-1 density</span>
				<ul class="li12">
					<li>
						HSFO：{{ dataList.jy018 }}
					</li>
					<li>
						LSFO：{{ dataList.jy01801 }}
					</li>
					<li>
						MDO：{{ dataList.jy01802 }}
					</li>
					<li>
						MGO：{{ dataList.jy01803 }}
					</li>
				</ul>
			</li>

			<li>
				<span>19、Barge-2 density</span>
				<ul class="li12">
					<li>
						HSFO：{{ dataList.jy019 }}
					</li>
					<li>
						LSFO：{{ dataList.jy01901 }}
					</li>
					<li>
						MDO：{{ dataList.jy01902 }}
					</li>
					<li>
						MGO：{{ dataList.jy01903 }}
					</li>
				</ul>
			</li>

			<li>
				<span>20、Barge-3 density</span>
				<ul class="li12">
					<li>
						HSFO：{{ dataList.jy020 }}
					</li>
					<li>
						LSFO：{{ dataList.jy02001 }}
					</li>
					<li>
						MDO：{{ dataList.jy02002 }}
					</li>
					<li>
						MGO：{{ dataList.jy02003 }}
					</li>
				</ul>
			</li>

			<li>
				<span>21、BDN Quantity of barge-1</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy021 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy02101 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy02102 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy02103 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>22、BDN Quantity of barge 2</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy022 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy02201 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy02202 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy02203 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>23、BDN Quantity of barge 3</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy023 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy02301 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy02302 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy02303 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>24、DIFFERENCE Quantity between vessel & barge 1</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy024 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy02401 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy02402 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy02403 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>25、DIFFERENCE Quantity between vessel & barge 2</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy025 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy02501 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy02502 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy02503 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>26、DIFFERENCE Quantity between vessel & barge 3</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy026 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy02601 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy02602 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy02603 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>27、大船 Oil Sample Quantity From Barge 1 </span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy027 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy02701 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy02702 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy02703 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>28、大船 Oil Sample Quantity From Barge 2</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy028 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy02801 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy02802 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy02803 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>29、大船 Oil Sample Quantity From Barge 3</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy029 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy02901 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy02902 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy02903 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>30、Oil sample serial no. from barge 1</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy030 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy03001 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy03002 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy03003 }}
				    </li>
				</ul>
			</li>

			<!-- <li>
				<span></span>
				<span>{{ dataList.jy031 }}</span>
			</li> -->
			<li>
				<span>31、Oil sample serial no. from barge 2</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy031 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy03101 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy03102 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy03103 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>32、Oil sample serial no. from barge 3</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy032 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy03201 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy03202 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy03203 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>33、Barge 1 HSFO or LSFO or MDO or LSMGO. oil sample serial no. （小船）:HSFO</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy033 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy03301 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy03302 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy03303 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>34、Barge 2 HSFO or LSFO or MDO or LSMGO. oil sample serial no. （小船</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy034 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy03401 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy03402 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy03403 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>35、Barge 3 HSFO or LSFO or MDO or LSMGO. oil sample serial no. （小船</span>
				<ul class="li12">
				    <li>
				        HSFO：{{ dataList.jy035 }}
				    </li>
				    <li>
				        LSFO：{{ dataList.jy03501 }}
				    </li>
				    <li>
				        MDO：{{ dataList.jy03502 }}
				    </li>
				    <li>
				        MGO：{{ dataList.jy03503 }}
				    </li>
				</ul>
			</li>

			<li>
				<span>36、Bunker Delivery Receipt From （上传图片）</span>
				<div style="color: #fff;">
					Barge 1
					<div class="imgs" v-if="dataList.jy036"><img :src="item" v-for="(item, index) in dataList.jy036.split('|')" /></div>
				</div>
				<div style="color: #fff;">
					Barge 2
					<div class="imgs" v-if="dataList.jy03601"><img :src="item" v-for="(item, index) in dataList.jy03601.split('|')" /></div>
				</div>
				<div style="color: #fff;">
					Barge 3
					<div class="imgs" v-if="dataList.jy03602"><img :src="item" v-for="(item, index) in dataList.jy03602.split('|')" /></div>
				</div>

			</li>


			<li>
				<span>37、Bunker Quantity Survey Report （上传图片）Barge 1:HSFO</span>
				<div style="color: #fff;">
					Barge 1
					<div class="imgs" v-if="dataList.jy037"><img :src="item" v-for="(item, index) in dataList.jy037.split('|')" /></div>
				</div>
				<div style="color: #fff;">
					Barge 2
					<div class="imgs" v-if="dataList.jy03701"><img :src="item" v-for="(item, index) in dataList.jy03701.split('|')" /></div>
				</div>
				<div style="color: #fff;">
					Barge 3
					<div class="imgs" v-if="dataList.jy03702"><img :src="item" v-for="(item, index) in dataList.jy03702.split('|')" /></div>
				</div>
			</li>

			<li>
				<span>38、Final Survey Report Summary</span>
				<div style="color: #fff;">
					Barge 1
					<div class="imgs" v-if="dataList.jy038"><img :src="item" v-for="(item, index) in dataList.jy038.split('|')" /></div>
				</div>
				<div style="color: #fff;">
					Barge 2
					<div class="imgs" v-if="dataList.jy03801"><img :src="item" v-for="(item, index) in dataList.jy03801.split('|')" /></div>
				</div>
				<div style="color: #fff;">
					Barge 3
					<div class="imgs" v-if="dataList.jy03802"><img :src="item" v-for="(item, index) in dataList.jy03802.split('|')" /></div>
				</div>
			</li>
			<li>
				<span>39、Final Vessel Quantity Report </span>
				<div style="color: #fff;">
					Barge 1
					<div class="imgs" v-if="dataList.jy039"><img :src="item" v-for="(item, index) in dataList.jy039.split('|')" /></div>
				</div>
				<div style="color: #fff;">
					Barge 2
					<div class="imgs" v-if="dataList.jy03901"><img :src="item" v-for="(item, index) in dataList.jy03901.split('|')" /></div>
				</div>
				<div style="color: #fff;">
					Barge 3
					<div class="imgs" v-if="dataList.jy03902"><img :src="item" v-for="(item, index) in dataList.jy03902.split('|')" /></div>
				</div>
			</li>
			<li>
			    <span>40、Supply Barge Quantity Report</span>
			    <div style="color: #fff;">
			        Barge 1
			        <div class="imgs" v-if="dataList.jy040"><img :src="item" v-for="(item, index) in dataList.jy040.split('|')" /></div>
			    </div>
			    <div style="color: #fff;">
			        Barge 2
			        <div class="imgs" v-if="dataList.jy04001"><img :src="item" v-for="(item, index) in dataList.jy04001.split('|')" /></div>
			    </div>
			    <div style="color: #fff;">
			        Barge 3
			        <div class="imgs" v-if="dataList.jy04002"><img :src="item" v-for="(item, index) in dataList.jy04002.split('|')" /></div>
			    </div>
			</li>
			<li>
			    <span>41、Bunker Sample Record </span>
			    <div style="color: #fff;">
			        Barge 1
			        <div class="imgs" v-if="dataList.jy041"><img :src="item" v-for="(item, index) in dataList.jy041.split('|')" /></div>
			    </div>
			    <div style="color: #fff;">
			        Barge 2
			        <div class="imgs" v-if="dataList.jy04101"><img :src="item" v-for="(item, index) in dataList.jy04101.split('|')" /></div>
			    </div>
			    <div style="color: #fff;">
			        Barge 3
			        <div class="imgs" v-if="dataList.jy04102"><img :src="item" v-for="(item, index) in dataList.jy04102.split('|')" /></div>
			    </div>
			</li>
			<li>
			    <span>42、Bunker Time Log</span>
			    <div style="color: #fff;">
			        Barge 1
			        <div class="imgs" v-if="dataList.jy042"><img :src="item" v-for="(item, index) in dataList.jy042.split('|')" /></div>
			    </div>
			    <div style="color: #fff;">
			        Barge 2
			        <div class="imgs" v-if="dataList.jy04201"><img :src="item" v-for="(item, index) in dataList.jy04201.split('|')" /></div>
			    </div>
			    <div style="color: #fff;">
			        Barge 3
			        <div class="imgs" v-if="dataList.jy04202"><img :src="item" v-for="(item, index) in dataList.jy04202.split('|')" /></div>
			    </div>
			</li>
			<li>
			    <span>43、Ship’s Particular</span>
			    <div style="color: #fff;">
			        <div class="imgs" v-if="dataList.jy043"><img :src="item" v-for="(item, index) in dataList.jy043.split('|')" /></div>
			    </div>

			</li>
			<li>
			    <span>44、电子签名</span>
			    <div style="color: #fff;">
			        <div class="imgs" v-if="dataList.jy044"><img  style="background: #fff;" :src="item" v-for="(item, index) in dataList.jy044.split('|')" /></div>
			    </div>

			</li>
			<li>
			    <span>45、Oil sample number drawn from the large vessel (oil from Barge 1)</span>
			    <ul class="li12">
			        <li>
			            HSFO：{{ dataList.jy045 }}
			        </li>
			        <li>
			            LSFO：{{ dataList.jy04501 }}
			        </li>
			        <li>
			            MDO：{{ dataList.jy04502 }}
			        </li>
			        <li>
			            MGO：{{ dataList.jy04503 }}
			        </li>
			    </ul>
			</li>
			<li>
			    <span>46、Oil sample number drawn from the large vessel (oil from Barge 2)</span>
			    <ul class="li12">
			        <li>
			            HSFO：{{ dataList.jy046 }}
			        </li>
			        <li>
			            LSFO：{{ dataList.jy04601 }}
			        </li>
			        <li>
			            MDO：{{ dataList.jy04602 }}
			        </li>
			        <li>
			            MGO：{{ dataList.jy04603 }}
			        </li>
			    </ul>
			</li>
			<li>
			    <span>47、Oil sample number drawn from the large vessel (oil from Barge 3)</span>
			    <ul class="li12">
			        <li>
			            HSFO：{{ dataList.jy047 }}
			        </li>
			        <li>
			            LSFO：{{ dataList.jy04701 }}
			        </li>
			        <li>
			            MDO：{{ dataList.jy04702 }}
			        </li>
			        <li>
			            MGO：{{ dataList.jy04703 }}
			        </li>
			    </ul>
			</li>
			<!-- <li>
				<span>39、上传电子签名</span>
				<img class="img" :src="dataList.jy040" />
			</li>
			<li>
				<span>40、上传电子签名</span>
				<img v-if="num == 0" class="img" :src="dataList.jy041" />
				<pdf v-if="num == 1" ref="pdf" :src="dataList.jy041"></pdf>
			</li> -->
      <li v-if="dataList.jy048 && dataList.jy048.split('|').length>0">
        <span>48、Video</span>
        <div class="imgs">
          <video :src="item" @click="togglePlayback(item)" width="100px" height="100px" style="margin-right: 10px" :key="index" v-for="(item, index) in dataList.jy048.split('|')" />
        </div>
      </li>

      <li>
        <span>49、Photo</span>
        <div style="color: #fff;">
          <div class="imgs" v-if="dataList.jy049"><img :src="item" v-for="(item, index) in dataList.jy049.split('|')" /></div>
        </div>

      </li>
		</div>

    <el-dialog
        title="视频"
        size="small"
        v-dialogDrag
        :visible.sync="isVisible"
        :before-close="handleClose">
      <div class="video-player">
        <!-- 视频元素 -->
        <video
            ref="videoPlayer"
            :src="videoSrc"
            style="width: 100%;height: auto;display: block;"
            @timeupdate="updateProgress"
            @play="onPlay"
            @pause="onPause"
            @loadedmetadata="onLoadedMetadata"
            />

        <!-- 控制栏 -->
        <div class="controls">
          <!-- 播放/暂停按钮 -->
          <button @click="togglePlayPause" class="control-btn">
            <i :class="isPlaying ? 'el-icon-video-pause' : 'el-icon-video-pause-play'"></i>
          </button>

          <!-- 进度条 -->
          <div class="progress-bar" @click="seekToTime">
            <div class="progress" :style="{ width: progress + '%' }"></div>
          </div>

          <!-- 时间显示 -->
          <span class="time">{{ currentTime }} / {{ duration }}</span>

          <!-- 全屏按钮 -->
          <button @click="toggleFullScreen" class="control-btn">
            <i class="fas fa-expand"></i>
          </button>
        </div>
      </div>
    </el-dialog>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import pdf from 'vue-pdf';
export default {
	name: 'ly',
	components: {
		navTop,
		pdf
	},
	data() {
		return {
			dataList: {},
			num: '',
      videoSrc: '', // 视频URL
      isPlaying: false, // 是否正在播放
      progress: 0, // 播放进度
      currentTime: '00:00', // 当前播放时间
      duration: '00:00', // 视频总时长
      videoList:[],
      isVisible:false
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulejy();
		}
	},
	methods: {
		getSchedulejy() {
			let data = {
				id: this.id
			};
			this.$api.schedulejy(data).then(res => {
				console.log(res,'333333333');
				if (res.result == 0) {
					if(res.data.jy012){
						res.data.jy01200=res.data.jy012
					}
					if(res.data.jy013){
						res.data.jy01300=res.data.jy013
					}
					this.dataList = res.data;
					if (res.data.jy041) {
						if (this.getSuffix(res.data.jy041) == 'pdf') {
							this.num = 1;
						} else {
							this.num = 0;
						}
					}
				}
			});
		},
		// 截取后缀名
		getSuffix(str) {
			var index = str.lastIndexOf('.');
			return str.substr(index + 1);
		},
    togglePlayback(item){
      this.videoSrc=item
      this.isVisible=true
    },

    // 切换播放/暂停
    togglePlayPause() {
      const video = this.$refs.videoPlayer;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },

    // 更新播放进度
    updateProgress() {
      const video = this.$refs.videoPlayer;
      this.progress = (video.currentTime / video.duration) * 100; // 计算进度百分比
      this.currentTime = this.formatTime(video.currentTime); // 格式化当前时间
    },

    // 跳转到指定时间
    seekToTime(event) {
      const video = this.$refs.videoPlayer;
      const progressBar = event.currentTarget;
      const clickPosition = event.offsetX; // 获取点击位置
      const progressBarWidth = progressBar.clientWidth; // 获取进度条宽度
      const seekTime = (clickPosition / progressBarWidth) * video.duration; // 计算跳转时间
      video.currentTime = seekTime;
    },

    // 播放事件
    onPlay() {
      this.isPlaying = true;
    },

    // 暂停事件
    onPause() {
      this.isPlaying = false;
    },

    // 视频元数据加载完成
    onLoadedMetadata() {
      const video = this.$refs.videoPlayer;
      this.duration = this.formatTime(video.duration); // 初始化总时长
    },

    // 切换全屏
    toggleFullScreen() {
      const video = this.$refs.videoPlayer;
      if (!document.fullscreenElement) {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          video.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },

    // 格式化时间（秒 -> MM:SS）
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    handleClose(){
      this.$refs.videoPlayer.pause();
      this.isVisible = false;
    }
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	span{color: #fff;}
	.li12 li{color: #fff !important;}
	.box {
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			a {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			.img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
			.imgs {
				margin-top: 15px;
				display: flex;
				flex-wrap: wrap;
				img {
					display: block;
					width: 392px;
					height: 292px;
					border-radius: 10px;
					margin-right: 58px;
					margin-bottom: 40px;
				}
				img:nth-child(3n) {
					margin-right: 0;
				}
			}
		}
	}
}
</style>
